module.exports = __webpack_public_path__ + "assets/img/ic-notlogin-day.375e8de7.svg";